module.exports = __webpack_public_path__ + "img/apple.6034b7a3.png";